import React from 'react'

const DeviceActivitiesModal = ({
  isOpen,
  onClose,
  onSave,
  isSaving,
  device,
  activities,
  selectedActivityIds,
  onToggleActivity
}) => {
  if (!isOpen) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4'>
      <div className='w-full max-w-2xl rounded-lg bg-white shadow-xl'>
        <div className='border-b px-6 py-4'>
          <h2 className='text-lg font-semibold text-gray-800'>
            Device Activities
          </h2>
          <p className='mt-1 text-sm text-gray-600'>
            {device?.identifier || 'Device'}
          </p>
        </div>

        <div className='max-h-[420px] overflow-y-auto px-6 py-4'>
          {activities.length === 0
            ? (
              <p className='text-sm text-gray-500'>No activities available.</p>
              )
            : (
              <div className='space-y-2'>
                {activities.map((activity) => {
                  const activityId = Number(activity.activityId)
                  const isChecked = selectedActivityIds.includes(activityId)

                  return (
                    <label
                      key={activityId}
                      className='flex cursor-pointer items-center justify-between rounded border px-3 py-2 hover:bg-gray-50'
                    >
                      <div className='flex flex-col'>
                        <span className='font-medium text-gray-800'>{activity.activityName}</span>
                        <span className='text-xs text-gray-500'>ID: {activityId}</span>
                      </div>
                      <input
                        type='checkbox'
                        checked={isChecked}
                        onChange={() => onToggleActivity(activityId)}
                        className='h-4 w-4'
                      />
                    </label>
                  )
                })}
              </div>
              )}
        </div>

        <div className='flex items-center justify-end gap-2 border-t px-6 py-4'>
          <button
            type='button'
            className='rounded border px-4 py-2 text-sm text-gray-700 hover:bg-gray-50'
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            type='button'
            className='rounded bg-greenPrimary px-4 py-2 text-sm text-white hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60'
            onClick={onSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Activities'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeviceActivitiesModal
